import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Chart from "react-apexcharts";
import { Stack, Typography } from '@mui/material';
import { getChartTitle, getSeriesName } from './trendChartutils'

import ReactECharts from "echarts-for-react";


const palette = [
    "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0",
    "#f46a9b", "#27aeef", "#b33dc6", "#ede15b", "#87bc45",
    "#9c4a44", "#F86624"]

const calculateAverage = (arrays) => {
    if (arrays.length === 0)
        return null;

    const result = Array(arrays[0].length).fill(null);

    arrays.forEach(array => {
        array.forEach((value, index) => {
            if (value !== null)
                result[index] += value/arrays.length;
        });
    });

    return result;

}

function TrendLineChart(props) {

    const MAX = 10;

    const { data, timeAggType, currencySymbol, graphType } = props;
    const { t } = useTranslation();

    let trends = data?.data ?? []

    trends = trends.filter((trend) => trend.metadata.key === graphType)

    const timestamps = (timeAggType === "q")? data?.timestamps.map((item)=>item.replace("Q1", "-01-01").replace("Q2", "-04-01").replace("Q3", "-07-01").replace("Q4", "-10-01")) : data?.timestamps;

    let series = [];

    let consolidatedTrends = [];

    // workaround to only select a MAX number of curves and create a fictitious "other" curve
    if (["TEMPERATURE", "SET_POINT"].includes(graphType)) {
        
        consolidatedTrends = trends.slice(0, MAX);

        if (trends.length > MAX){

            const otherTrends = trends.slice(MAX, trends.length);

            const average = calculateAverage(otherTrends.map((t)=>t.values));

            consolidatedTrends.push(
                {
                    metadata: {
                        key: graphType,
                        other: true
                    },
                    values: average
                }
            )
        }

    } else {
        consolidatedTrends = trends;
    }

    consolidatedTrends.forEach((trend) => {

        const curve = trend.metadata;

        const name = getSeriesName(curve, t)

        let s = {
            name: name,
            data: trend.values,
            type: 'line',
            symbol: 'none',
            lineStyle: {
                width: 3
            }
        }

        series.push(s)


    })

    let options = {
		tooltip: {
            confine: true,
			trigger: "axis",
			valueFormatter: (value) =>
				typeof value == "number" ? value.toLocaleString(navigator.language,{
                    minimumFractionDigits:2,
                    maximumFractionDigits:2
                }) : value,
		},
		grid: {
			top: '4%',
            left: '4%',
            containLabel: true,
            right: '5%',
            bottom: 30
		},
		legend: {
			show: true,
			bottom: 0, 
			left: "center",
            symbol: 'none',
            type: 'scroll',
            width: '80%', 
            height: 200,
            itemGap: 20,
		},
		xAxis: {
            type: 'category',
			data: timestamps,
			silent: false,

		},
		yAxis: {
            min: (value) => {
                return value.min
            },
            axisLabel: {
                formatter: function (value){
                    return Math.ceil(value)
                }
            },
        },
		series: series,
        textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
        },
	};

    if (series.length === 1) {
        options.legend = {
            show: false,
            top: '10%'
        }
        options.grid.bottom = '0%'
    }

    
    const title = getChartTitle(graphType, t, currencySymbol)


    return (
        <Stack>
            <Typography paddingTop={'30px'}  align="center" component="h2" variant="h6" color="primary" >{title}</Typography>
            <ReactECharts option={options} notMerge={true} lazyUpdate={false}/>
        </Stack>
        
    )

};

export default TrendLineChart;